<template>
    <div>
        <div v-if="successMessage" class="alert alert-success" style="color: rgb(5, 20, 48)">
            {{ successMessage }}
        </div>
        <b-card>
            <b-row>
                <div class="col-12 mt-16">
                    <b-form @submit.prevent="addUser" v-if="show">
                        <div style="
                background-color: rgb(97, 116, 152);
                height: 32px;
                border-radius: 4px;
              ">
                            <h4 style="
                  color: rgb(223, 227, 238);
                  margin-left: 5px;
                  font-weight: bold;
                ">
                                Police Information
                            </h4>
                        </div>
                        <div class="row">
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-1" label="First Name:" label-for="first_name">
                                    <b-form-input id="first_name" type="text" placeholder="Enter first name"   :state="validateField(first_name, 'text')"  autocomplete="off"
                                        v-model="first_name" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-1" label="Middle Name:" label-for="second_name">
                                    <b-form-input id="second_name" type="text" placeholder="Enter  second name"   :state="validateField(second_name, 'text')"  autocomplete="off"
                                        v-model="second_name" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-1" label="Last Name:" label-for="last_name">
                                    <b-form-input id="last_name" type="text" placeholder="Enter  last name" :state="validateField(last_name, 'text')"  autocomplete="off"
                                        v-model="last_name" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-1" label="Second Surname:" label-for="second_last_name">
                                    <b-form-input id="second_last_name" type="text" placeholder="Enter second surname" :state="validateField(second_last_name, 'text')"  autocomplete="off"
                                        v-model="second_last_name" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-1" label="Date of Birth:" label-for="birthdate">
                                    <b-form-input id="birthdate" type="date" placeholder="Enter date of  birth" :state="validateField(birthdate)"  autocomplete="off"
                                        v-model="birthdate" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Zip Code:" label-for="postcode">
                                    <b-form-input id="postcode" type="text" placeholder="Enter Zip code" :state="validateField(postcode)"
                                        v-model="postcode" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Address:" label-for="street_address">
                                    <b-form-input id="street_address" type="text" placeholder="Enter street address" :state="validateField(street_address)"
                                        v-model="street_address" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                           

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Email Address:" label-for="email">
                                    <b-form-input id="email" type="email" placeholder="Enter email address"   :state="validateField(email, 'email')" 
                                        v-model="email" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-1" label="Mobile:" label-for="phone_number">
                                    <b-form-input id="phone_number" placeholder="Enter phone  number"   :state="validateField(phone_number, 'number')" 
                                        v-model="phone_number" pattern="[0-9]+" title="Please enter only numeric characters"
                                        required>
                                    </b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Country:" label-for="country">
                                    <v-select id="country" v-model="selectedCountry" :options="countryOptions" label="name"
                                        track-by="isoCode" placeholder="Select country" :clearable="true" :filterable="true">
                                    </v-select>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="City:" label-for="city">
                                    <v-select id="city" v-model="selectedCity" :options="cityOptions" label="name"
                                        track-by="id" placeholder="Select city" :clearable="true" :filterable="true"
                                        :disabled="!selectedCountry || !cityOptions.length">
                                    </v-select>
                                    <b-form-invalid-feedback v-if="selectedCountry && !cityOptions.length" class="d-block">
                                        No cities available for the selected country.
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Password:" label-for="password">
                                    <b-form-input id="password" placeholder="Enter password" :state="validateField(password)" v-model="password">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                          
                        <!-- Profile Picture -->
                        <div class="col-md-4 col-12">
                            <b-form-group label="Profile Picture:" label-for="image" label-class="font-weight-bold">
                            <div class="border rounded p-3 text-center"
                                style="cursor: pointer; background: #f9f9f9;"
                                @drop.prevent="onImageDrop"
                                @dragover.prevent
                                @click="$refs.profileInput.click()">
                                <div v-if="!imagePreview">
                                <i class="fas fa-cloud-upload-alt fa-2x text-muted"></i>
                                <p class="mb-0">Drag & Drop or Click to Upload</p>
                                </div>
                                <div v-else>
                                <img :src="imagePreview" alt="Preview" class="img-thumbnail" style="max-height: 120px;" />
                                </div>
                                <input ref="profileInput" type="file" accept="image/png, image/jpeg"
                                    class="d-none" @change="onProfilePictureChange" />
                            </div>
                            <small class="text-muted">Only JPG/PNG, Max size: 2MB</small>
                            <b-form-invalid-feedback v-if="profileError" class="d-block text-danger">
                                {{ profileError }}
                            </b-form-invalid-feedback>
                            </b-form-group>
                        </div>

                        </div>
                        <b-button type="submit" variant="primary" class="mb-8 mr-8" :disabled="isLoading">
                            <span v-if="!isLoading">Submit</span>
                            <b-spinner v-else class="mb-8 mr-8" variant="primary" small></b-spinner>
                        </b-button>
                    </b-form>
                </div>
                
                <div v-if="codeActive" class="col-12 mt-24 hljs-container" :class="{ active: codeActiveClass }">
                    <pre v-highlightjs>
            <code class="hljs html">
              {{ codeText }}
            </code>
          </pre>
                </div>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import {
    BRow,
    BCol,
    BCard,
    BButton,
    BForm,
    BFormGroup,
    BFormCheckboxGroup,
    BFormCheckbox,
    BFormInput,
    BSpinner,
    BFormInvalidFeedback,
} from "bootstrap-vue";
import axios from "../../../axios";
import { BToast } from "bootstrap-vue";
import code from "@/view/components/data-entry/form/code";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { Country, City } from "country-state-city";

export default {
    data() {
        return {
            show: true,
            codeText: code.introduction,
            codeActive: false,
            codeActiveClass: false,
            showModal: false,
            isLoading: false,
            first_name: "",
            second_name:"",
            last_name:"",
            second_last_name:"",
            birthdate:"",
            postcode:"",
            street_address:"",
            type:"police",
            password:"",
            city: '',
            country:'',
            password: '',
            email: "",
            phone_number: "",   
            image: '',
            selectedCountry: null,
            selectedCity: null,
            countryOptions: [],
            cityOptions: [],
            successMessage: "",
            errorMessage: "",
            imagePreview: null,
            profileError: "",
        };
    },
    components: {
        BRow,
        BCol,
        BCard,
        BButton,
        BForm,
        BFormGroup,
        BFormCheckboxGroup,
        BFormCheckbox,
        BFormInput,
        BToast,
        BSpinner,
        BFormInvalidFeedback,
        vSelect,
    },

    created() {
        this.countryOptions = Country.getAllCountries().map(({ name, isoCode }) => ({
            name,
            isoCode,
        }));
    },

    watch: {
        selectedCountry(newVal) {
            if (!newVal) {
                this.country = "";
                this.city = "";
                this.cityOptions = [];
                this.selectedCity = null;
                return;
            }
            this.country = newVal.name;
            this.selectedCity = null;
            this.city = "";
            this.cityOptions = City.getCitiesOfCountry(newVal.isoCode).map(({ name, countryCode, stateCode }) => ({
                name,
                id: `${countryCode}-${stateCode || "NA"}-${name}`,
            }));
        },
        selectedCity(newVal) {
            this.city = newVal ? newVal.name : "";
        },
    },


    methods: {
        validateField(value, type = "text") {
            if (value === null || value === undefined || value === "") return null;

            if (type === "email") {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return regex.test(value);
            }
            if (type === "number") {
            const regex = /^\+?[0-9 ]+$/; // accepts + and spaces
            return regex.test(value.toString().trim());
            }
            return value.toString().trim().length > 0;
        },
        showMsgBoxOne() {
            debugger;
        },
        onSubmit(event) {
            event.preventDefault();
            alert(JSON.stringify(this.form));
            // debugger
        },
        addUser() {
            this.isLoading = true;
            // Create a FormData object to handle the image file
            const formData = new FormData();
            formData.append("first_name", this.first_name);
            formData.append("second_name", this.second_name);
            formData.append("last_name", this.last_name);
            formData.append("second_last_name", this.second_last_name);
            formData.append("birthdate", this.birthdate);
            formData.append("postcode", this.postcode);
            formData.append("street_address", this.street_address);
            formData.append("type", this.type);
            formData.append("city", this.city);
            formData.append("country", this.country);
            formData.append("password", this.password);
            formData.append("email", this.email);
            formData.append("phone_number", this.phone_number);
            if (this.image instanceof File) {
                formData.append("image", this.image);
            }
          
            axios

                .post("PoliceAdd", formData)
                .then((response) => {
                    this.$bvToast.toast("Police added successfully!", {
                        title: "Success",
                        variant: "primary",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-right",
                        autoHideDelay: 5000,
                    });
                    this.isLoading = false;
                    this.$router.push({ name: 'ListPolice' });
                })
                .catch((error) => {
                    this.errors = error.response.data.errors;
                    this.isLoading = false;
                    if (error.response && error.response.data && error.response.data.message) {
                        this.$bvToast.toast(error.response.data.message, {
                            title: "Error",
                            variant: "danger",
                            solid: true,
                            toaster: "b-toaster-top-right",
                            autoHideDelay: 5000,
                        });
                    } else {
                        this.$bvToast.toast("Something went wrong. Please try again.", {
                            title: "Error",
                            variant: "danger",
                            solid: true,
                            toaster: "b-toaster-top-right",
                            autoHideDelay: 5000,
                        });
                    }
                });
        },
    
        onProfilePictureChange(e) {
            const file = e.target.files[0];
            if (!file) return;

            if (!["image/jpeg", "image/png"].includes(file.type)) {
                this.profileError = "Only JPG/PNG allowed."; return;
            }
            if (file.size > 2 * 1024 * 1024) {
                this.profileError = "Max size is 2MB."; return;
            }

            this.image = file;
            this.imagePreview = URL.createObjectURL(file);
            this.profileError = "";
            },

            onImageDrop(e) {
            const file = e.dataTransfer.files[0];
            this.onProfilePictureChange({ target: { files: [file] } });
            },
        codeClick() {
            this.codeActive = !this.codeActive;
        },

        saveOwnCar() {
            this.showModal = false;
        },
    },
};
</script>